import strings from "asset/constant/strings";
import priceFormatter from "./priceFormatter";
import { Platform } from "react-native";

const makeFactorPdfTemplate = (data: FactorT) =>
  `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <style>
          @font-face {
            font-family: defaultFont;
            src: url( ${
              Platform.OS === "web"
                ? "/static/media/IRANYekanMobile-Regular-FA.423b61df834b3ad715b8.ttf"
                : "file:///android_asset/fonts/IRANYekanMobile-Regular-FA.ttf"
            } )
          }

          * {
            direction: rtl;
            font-family: defaultFont;
          }

          .container {
            width: 90%;
            margin: auto;
            min-width: 400px;
            max-width: 1024px;
          }

          .styled-table {
            width: 100%;
            font-size: 0.9em;
          }

          .styled-table th,
          .styled-table td {
            padding: 12px 15px;
          }

          .styled-table thead tr {
            color: #fff;
            text-align: right;
            background-color: #555;
          }

          .styled-table tbody tr {
            text-align: right;
            border-bottom: 1px solid #dddddd;
          }
    
          .styled-table tbody tr:nth-of-type(even) {
            background-color: #f3f3f3;
          }

          .header {
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;
          }

          .logo {
            width: 100px;
            height: 100px;
            border-radius: 15%;
          }

          .company-name {
            font-size: 16px;
          }

          .total {
            display: flex;
            flex-flow: row;
            width: 90%;
            padding: 20px;
            font-size: large;
            border: 2px solid #aaa;
            justify-content: space-between;
            border-radius: 20px 20px 20px 20px;
            margin: auto;
            margin-top: 10px;
          }
        </style>
      </head>
      <body>
          <div class="container">
            <div class="header">
              <div>
                <p class="company-name">${data?.company_name}</p>
                <p>فاکتور شماره: ${data?.id}</p>
              </div>
              <div>
                <p>تاریخ ثبت سفارش: ${data?.created_at}</p>
                <p>تاریخ تایید سفارش: ${
                  data?.change_status_at
                    ? data?.change_status_at
                    : data?.status?.title
                }</p>
              </div>
            </div>

            <table class="styled-table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>محصول</th>
                  <th>تعداد</th>
                  <th>قیمت واحد</th>
                  <th>مجموع</th>
                </tr>
              </thead>
              <tbody>
                ${data?.items
                  ?.map((product: FactorItemsDataT, key: number) => {
                    return `<tr>
                  <td>${key + 1}</td>
                  <td>${product?.product_name} ${
                      product?.new_attributes &&
                      "(" +
                        product?.new_attributes
                          ?.map(
                            (attr: any) =>
                              `${attr
                                ?.replace("×", "*")
                                ?.split("*")
                                ?.reverse()
                                .join("*")}`
                          )
                          .join(" , ") +
                        ")" +
                        `${
                          product.description ? " - " + product.description : ""
                        }`
                    }</td>
                  <td>${product?.count}</td>
                  <td>${
                    product.description ? "-" : priceFormatter(product.price)
                  }</td>
                  <td>${
                    product.description
                      ? "-"
                      : priceFormatter(product.total_price)
                  }</td>
                </tr>`;
                  })
                  .join("")}
              </tbody>
            </table>
            <div class="total">
              <p>جمع کل</p>
              <p>${priceFormatter(data?.total) + " " + strings.currency}</p>
            </div>
            ${data?.description ? "<br/>" : ""}
            ${
              data?.description ? '<p style="margin-top:50px">توضیحات:</p>' : ""
            }
            ${data?.description ? "<p>" + data?.description + "</p>" : ""}
            
          </div>
      </body>
    </html>    
    `;

export default makeFactorPdfTemplate;
